(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('ParameterizationDocsController', ParameterizationDocsController);

    ParameterizationDocsController.$inject = ['ParameterizationDocsService', '$translate'];

    function ParameterizationDocsController(ParameterizationDocsService, $translate) {
        var vm = this;

        // State
        vm.loading = true;
        vm.error = false;
        vm.searchQuery = '';
        vm.activeTab = 'actions';
        vm.selectedAction = null;
        vm.selectedDefinition = null;
        vm.expandedDefinitions = {};
        vm.categoryFilter = '';

        // Action definitions tab state
        vm.actionDefinitions = [];
        vm.actionsLoaded = false;

        // Communication definitions tab state (paginated)
        vm.commDefinitions = [];
        vm.commDefinitionsTotal = 0;
        vm.commDefinitionsPage = 0;
        vm.commDefinitionsLoading = false;
        vm.commDefinitionsLoaded = false;
        vm.commDefinitionsSearch = '';

        // Resolution tab state
        vm.definitionFilter = '';
        vm.definitionSummaries = [];
        vm.definitionSummariesTotal = 0;
        vm.definitionSummariesPage = 0;
        vm.definitionSummariesLoading = false;
        vm.resolutionDefinition = null;
        vm.resolutionSteps = [];
        vm.resolutionStepsLoading = false;
        vm.resolutionStep = null;
        vm.resolutionDetail = null;
        vm.resolutionDetailLoading = false;
        vm.showLevelDetail = false;

        // Parameter resolution info
        vm.parameterResolution = null;

        // Methods
        vm.setActiveTab = setActiveTab;
        vm.selectAction = selectAction;
        vm.selectDefinition = selectDefinition;
        vm.toggleDefinitionExpand = toggleDefinitionExpand;
        vm.filteredActionDefinitions = filteredActionDefinitions;
        vm.getParameterCategories = getParameterCategories;
        vm.setCategoryFilter = setCategoryFilter;
        vm.getFilteredParameters = getFilteredParameters;
        vm.getCategoryIcon = getCategoryIcon;
        vm.formatAuthority = formatAuthority;
        vm.getUsageLabel = getUsageLabel;
        vm.getSimpleClassName = getSimpleClassName;
        vm.selectResolutionDefinition = selectResolutionDefinition;
        vm.selectResolutionStep = selectResolutionStep;
        vm.searchDefinitionSummaries = searchDefinitionSummaries;
        vm.loadMoreDefinitions = loadMoreDefinitions;
        vm.getStepParameterSummary = getStepParameterSummary;
        vm.isSensitiveParam = isSensitiveParam;
        vm.searchCommDefinitions = searchCommDefinitions;
        vm.loadMoreCommDefinitions = loadMoreCommDefinitions;
        vm.retryLoad = loadActionDefinitions;

        // Init - only load action definitions (first tab)
        loadActionDefinitions();

        function loadActionDefinitions() {
            vm.loading = true;
            vm.error = false;
            ParameterizationDocsService.getActionDefinitions().then(
                function(data) {
                    vm.actionDefinitions = data;
                    vm.actionsLoaded = true;
                    vm.loading = false;
                },
                function() {
                    vm.error = true;
                    vm.loading = false;
                }
            );
        }

        function loadCommDefinitions() {
            if (vm.commDefinitionsLoaded) return;
            vm.commDefinitionsLoading = true;
            vm.commDefinitionsPage = 0;
            ParameterizationDocsService.getDefinitionSummaries(vm.commDefinitionsSearch, 0, 50).then(
                function(result) {
                    vm.commDefinitions = result.data;
                    vm.commDefinitionsTotal = result.totalCount;
                    vm.commDefinitionsLoading = false;
                    vm.commDefinitionsLoaded = true;
                },
                function() {
                    vm.commDefinitionsLoading = false;
                }
            );
        }

        var commSearchTimeout = null;
        function searchCommDefinitions() {
            if (commSearchTimeout) clearTimeout(commSearchTimeout);
            commSearchTimeout = setTimeout(function() {
                vm.commDefinitionsPage = 0;
                vm.commDefinitionsLoading = true;
                vm.commDefinitionsLoaded = false;
                vm.selectedDefinition = null;
                ParameterizationDocsService.getDefinitionSummaries(vm.commDefinitionsSearch, 0, 50).then(
                    function(result) {
                        vm.commDefinitions = result.data;
                        vm.commDefinitionsTotal = result.totalCount;
                        vm.commDefinitionsLoading = false;
                        vm.commDefinitionsLoaded = true;
                    },
                    function() {
                        vm.commDefinitionsLoading = false;
                    }
                );
            }, 300);
        }

        function loadMoreCommDefinitions() {
            if (vm.commDefinitionsLoading) return;
            if (vm.commDefinitions.length >= vm.commDefinitionsTotal) return;
            vm.commDefinitionsPage++;
            vm.commDefinitionsLoading = true;
            ParameterizationDocsService.getDefinitionSummaries(vm.commDefinitionsSearch, vm.commDefinitionsPage, 50).then(
                function(result) {
                    vm.commDefinitions = vm.commDefinitions.concat(result.data);
                    vm.commDefinitionsLoading = false;
                },
                function() {
                    vm.commDefinitionsLoading = false;
                }
            );
        }

        function setActiveTab(tab) {
            vm.activeTab = tab;
            vm.selectedAction = null;
            vm.selectedDefinition = null;
            vm.categoryFilter = '';
            if (tab === 'definitions' && !vm.commDefinitionsLoaded) {
                loadCommDefinitions();
            }
            if (tab === 'resolution' && vm.definitionSummaries.length === 0) {
                searchDefinitionSummaries();
            }
        }

        function selectAction(action) {
            vm.selectedAction = action;
            vm.categoryFilter = '';
        }

        function selectDefinition(definition) {
            vm.selectedDefinition = definition;
            vm.expandedDefinitions = {};
            // Lazy-load workflow steps for this definition
            if (definition && !definition.workflowSteps) {
                definition.workflowStepsLoading = true;
                ParameterizationDocsService.getDefinitionSteps(definition.id).then(
                    function(steps) {
                        definition.workflowSteps = steps;
                        definition.workflowStepsLoading = false;
                    },
                    function() {
                        definition.workflowSteps = [];
                        definition.workflowStepsLoading = false;
                    }
                );
            }
        }

        function toggleDefinitionExpand(defId) {
            vm.expandedDefinitions[defId] = !vm.expandedDefinitions[defId];
        }

        function filteredActionDefinitions() {
            if (!vm.actionDefinitions) return [];
            if (!vm.searchQuery) return vm.actionDefinitions;

            var query = vm.searchQuery.toLowerCase();
            return vm.actionDefinitions.filter(function(ad) {
                return (ad.name && ad.name.toLowerCase().indexOf(query) !== -1) ||
                       (ad.communicationType && ad.communicationType.toLowerCase().indexOf(query) !== -1) ||
                       (ad.classname && ad.classname.toLowerCase().indexOf(query) !== -1) ||
                       hasMatchingParameter(ad, query);
            });
        }

        function hasMatchingParameter(actionDef, query) {
            if (!actionDef.parameters) return false;
            return actionDef.parameters.some(function(p) {
                return p.parameterType && p.parameterType.toLowerCase().indexOf(query) !== -1;
            });
        }

        function getParameterCategories() {
            if (!vm.selectedAction || !vm.selectedAction.parameters) return [];
            var categories = {};
            vm.selectedAction.parameters.forEach(function(p) {
                if (p.category) {
                    categories[p.category] = true;
                }
            });
            return Object.keys(categories).sort();
        }

        function setCategoryFilter(category) {
            vm.categoryFilter = (vm.categoryFilter === category) ? '' : category;
        }

        function getFilteredParameters() {
            if (!vm.selectedAction || !vm.selectedAction.parameters) return [];
            if (!vm.categoryFilter) return vm.selectedAction.parameters;
            return vm.selectedAction.parameters.filter(function(p) {
                return p.category === vm.categoryFilter;
            });
        }

        function getCategoryIcon(category) {
            var icons = {
                'connection': 'fas fa-plug',
                'file': 'fas fa-file',
                'filtering': 'fas fa-filter',
                'security': 'fas fa-shield-alt',
                'signature': 'fas fa-pen-nib',
                'email': 'fas fa-envelope',
                'scheduling': 'fas fa-clock',
                'business': 'fas fa-briefcase'
            };
            return icons[category] || 'fas fa-cog';
        }

        function formatAuthority(auth) {
            if (!auth) return '';
            return auth.replace('ROLE_', '');
        }

        function getUsageLabel(count) {
            var label = $translate.instant('parameterizationDocs.actions.usageCountHint');
            return count + ' ' + label;
        }

        function getSimpleClassName(classname) {
            if (!classname) return '';
            var parts = classname.split('.');
            return parts[parts.length - 1];
        }

        function getStepParameterSummary(step) {
            var total = (step.originParameterCount || 0) + (step.destinationParameterCount || 0);
            if (total === 0) return '';
            var parts = [];
            if (step.originParameterCount > 0) parts.push(step.originParameterCount + ' orig.');
            if (step.destinationParameterCount > 0) parts.push(step.destinationParameterCount + ' dest.');
            return parts.join(', ');
        }

        function isSensitiveParam(paramType) {
            return paramType === 'PASSWORD' || paramType === 'KEYSTORE_PASSWORD' || paramType === 'PUBLIC_KEY';
        }

        // === Resolution tab: lazy-loaded definition/step picker ===

        var searchTimeout = null;
        function searchDefinitionSummaries() {
            if (searchTimeout) clearTimeout(searchTimeout);
            searchTimeout = setTimeout(function() {
                vm.definitionSummariesPage = 0;
                vm.definitionSummariesLoading = true;
                vm.resolutionDefinition = null;
                vm.resolutionSteps = [];
                vm.resolutionStep = null;
                vm.resolutionDetail = null;
                ParameterizationDocsService.getDefinitionSummaries(vm.definitionFilter, 0, 20).then(
                    function(result) {
                        vm.definitionSummaries = result.data;
                        vm.definitionSummariesTotal = result.totalCount;
                        vm.definitionSummariesLoading = false;
                    },
                    function() {
                        vm.definitionSummariesLoading = false;
                    }
                );
            }, 300);
        }

        function loadMoreDefinitions() {
            if (vm.definitionSummariesLoading) return;
            if (vm.definitionSummaries.length >= vm.definitionSummariesTotal) return;
            vm.definitionSummariesPage++;
            vm.definitionSummariesLoading = true;
            ParameterizationDocsService.getDefinitionSummaries(vm.definitionFilter, vm.definitionSummariesPage, 20).then(
                function(result) {
                    vm.definitionSummaries = vm.definitionSummaries.concat(result.data);
                    vm.definitionSummariesLoading = false;
                },
                function() {
                    vm.definitionSummariesLoading = false;
                }
            );
        }

        function selectResolutionDefinition(def) {
            vm.resolutionDefinition = def;
            vm.resolutionStep = null;
            vm.resolutionDetail = null;
            vm.resolutionSteps = [];
            vm.resolutionStepsLoading = true;
            ParameterizationDocsService.getDefinitionSteps(def.id).then(
                function(steps) {
                    vm.resolutionSteps = steps;
                    vm.resolutionStepsLoading = false;
                },
                function() {
                    vm.resolutionStepsLoading = false;
                }
            );
        }

        function selectResolutionStep(step) {
            vm.resolutionStep = step;
            vm.resolutionDetail = null;
            vm.resolutionDetailLoading = true;
            vm.showLevelDetail = false;
            ParameterizationDocsService.getStepResolution(step.id).then(
                function(detail) {
                    vm.resolutionDetail = detail;
                    vm.resolutionDetailLoading = false;
                },
                function() {
                    vm.resolutionDetailLoading = false;
                }
            );
        }
    }
})();
